// extracted by mini-css-extract-plugin
module.exports = {"highlight":"Search_highlight__2AcJK","collapseActionContainer":"Search_collapseActionContainer__2Mjlr","buttonsWrapper":"Search_buttonsWrapper__LDaB5"};